<template>
  <div class="py-4 container-fluid">
    <!-- <a class="btn btn-sm btn-primary" style="margin-right: 10px;" :href="apiUrl+'print-pdf/dashboard-purchasing?pr_code='+search.pr_code+'&project_type='+search.project_type+'&part_name='+search.part_name+'&specification='+search.specification+'&size='+search.size+'&status='+search.status+'&date_required='+search.date_required+'&request_by='+search.request_by+'&buyer='+search.buyer+''" target="_BLANK"><i class="fa fa-file-pdf-o"></i> Export to PDF</a> -->
    <div class="row">
    	<!-- <div class="col-lg-2 col-md-6 col-12">
        <card
          title="Total Work Order"
          :value="(totalWo)"
          iconClass="fa fa-briefcase"
          iconBackground="bg-gradient-primary"
          directionReverse
        ></card>
      </div> -->
      <div class="col-lg-2 col-md-6 col-12">
        <card
          title="Total Vendor"
          :value="(totalVendor)"
          iconClass="fa fa-handshake"
          iconBackground="bg-gradient-secondary"
          directionReverse
        ></card>
      </div>
      <div class="col-lg-2 col-md-6 col-12">
        <card
          title="Total Items"
          :value="(totalItem)"
          iconClass="fa fa-sitemap"
          iconBackground="bg-gradient-success"
          directionReverse
        ></card>
      </div>
      <div class="col-lg-2 col-md-6 col-12">
        <card
          title="Total PR"
          :value="(totalPr)"
          iconClass="fa fa-book"
          iconBackground="bg-gradient-danger"
          directionReverse
        ></card>
      </div>
      <div class="col-lg-2 col-md-6 col-12">
        <card
          title="Total RFQ"
          :value="(totalRfq)"
          iconClass="fa fa-question-circle"
          iconBackground="bg-gradient-warning"
          directionReverse
        ></card>
      </div>
      <div class="col-lg-2 col-md-6 col-12">
        <card
          title="Total CP"
          :value="(totalCp)"
          iconClass="fa fa-thumbs-up"
          iconBackground="bg-gradient-info"
          directionReverse
        ></card>
      </div>
      <div class="col-lg-2 col-md-6 col-12">
        <card
          title="Total PO"
          :value="(totalPo)"
          iconClass="fa fa-cart-arrow-down"
          iconBackground="bg-gradient-dark"
          directionReverse
        ></card>
      </div>
    </div>

    <div class="row mb-4">
      <div class="col-5">
        <div class="card" style="height: 410px;"> 
          <!-- <div class="card-header pb-0 text-left align-content-start">
          </div> -->
          <div class="card-body">
            <h6 class="text-left">Item Group</h6>
            <div class="row justify-content-center">
              <div class="col-lg-6">
                <Pie
                  id="my-chart-id"
                  :options="chartOptions"
                  :data="chartData" 
                  style="width: 300px; height: 300px;"
                />
              </div>
            </div>
          </div>
        </div>
      </div>

    	<div class="col-lg-7">
    		<div class="card">
			    <div class="p-3 pb-0 card-header">
			      <div class="d-flex align-items-center">
			        <h6 class="mb-0">Item Category</h6>
			        <button
			          type="button"
			          class="mb-0 btn btn-icon-only btn-rounded btn-outline-secondary ms-2 btn-sm d-flex align-items-center justify-content-center ms-auto"
			          data-bs-toggle="tooltip"
			          data-bs-placement="bottom"
			          title="See the Item Category"
			        >
			          <i class="fas fa-info"></i>
			        </button>
			      </div>
			    </div>
			    <div class="p-3 card-body">
			      <div class="row">
			        <div class="text-center col-5">
			          <div class="chart">
			            <canvas id="chart-category" class="chart-canvas" height="300"></canvas>
			          </div>
			          <h4 class="font-weight-bold mt-n9">
			            <span>{{ totalItem }}</span>
			            <span class="text-sm d-block text-body">ITEMS</span>
			          </h4>
			        </div>
			        <div class="col-7">
			          <div class="table-responsive">
			            <table class="table mb-0 align-items-center">
			              <tbody>
			                <tr>
			                  <td>
			                    <div class="px-2 py-0 d-flex">
			                      <span class="badge bg-primary me-2">&nbsp;</span>
			                      <div class="d-flex flex-column justify-content-center">
			                        <h6 class="mb-0 text-sm">MATERIAL</h6>
			                      </div>
			                    </div>
			                  </td>
			                  <td class="text-sm text-center align-middle">
			                    <span class="text-xs font-weight-bold">{{ totPersenMtr }} %</span>
			                  </td>
			                </tr>
			                <tr>
			                  <td>
			                    <div class="px-2 py-0 d-flex">
			                      <span class="badge bg-secondary me-3">&nbsp;</span>
			                      <div class="d-flex flex-column justify-content-center">
			                        <h6 class="mb-0 text-sm">CONSUMABLE</h6>
			                      </div>
			                    </div>
			                  </td>
			                  <td class="text-sm text-center align-middle">
			                    <span class="text-xs font-weight-bold">{{ totPersenCons }} %</span>
			                  </td>
			                </tr>
			                <tr>
			                  <td>
			                    <div class="px-2 py-0 d-flex">
			                      <span class="badge bg-info me-3">&nbsp;</span>
			                      <div class="d-flex flex-column justify-content-center">
			                        <h6 class="mb-0 text-sm">WORKSHOP SERVICES</h6>
			                      </div>
			                    </div>
			                  </td>
			                  <td class="text-sm text-center align-middle">
			                    <span class="text-xs font-weight-bold">{{ totPersenWs }}%</span>
			                  </td>
			                </tr>
			                <tr>
			                  <td>
			                    <div class="px-2 py-0 d-flex">
			                      <span class="badge bg-success me-3">&nbsp;</span>
			                      <div class="d-flex flex-column justify-content-center">
			                        <h6 class="mb-0 text-sm">TOOLS AND EQUIPMENTS</h6>
			                      </div>
			                    </div>
			                  </td>
			                  <td class="text-sm text-center align-middle">
			                    <span class="text-xs font-weight-bold">{{ totPersenTools }}%</span>
			                  </td>
			                </tr>
			                <tr>
			                  <td>
			                    <div class="px-2 py-0 d-flex">
			                      <span class="badge bg-warning me-3">&nbsp;</span>
			                      <div class="d-flex flex-column justify-content-center">
			                        <h6 class="mb-0 text-sm">OFFICE EQUIPMENT</h6>
			                      </div>
			                    </div>
			                  </td>
			                  <td class="text-sm text-center align-middle">
			                    <span class="text-xs font-weight-bold">{{ totPersenOfficeEquip }}%</span>
			                  </td>
			                </tr>
			                <tr>
			                  <td>
			                    <div class="px-2 py-0 d-flex">
			                      <span class="badge bg-dark me-3">&nbsp;</span>
			                      <div class="d-flex flex-column justify-content-center">
			                        <h6 class="mb-0 text-sm">GENERAL AND ADMINISTRATIVE</h6>
			                      </div>
			                    </div>
			                  </td>
			                  <td class="text-sm text-center align-middle">
			                    <span class="text-xs font-weight-bold">{{ totPersenGenAdm }}%</span>
			                  </td>
			                </tr>
			                <tr>
			                  <td>
			                    <div class="px-2 py-0 d-flex">
			                      <span class="badge bg-danger me-3">&nbsp;</span>
			                      <div class="d-flex flex-column justify-content-center">
			                        <h6 class="mb-0 text-sm">FINISHING GOODS</h6>
			                      </div>
			                    </div>
			                  </td>
			                  <td class="text-sm text-center align-middle">
			                    <span class="text-xs font-weight-bold">{{ totPersenFinishGoods }}%</span>
			                  </td>
			                </tr>
			                <tr>
			                  <td>
			                    <div class="px-2 py-0 d-flex">
			                      <span class="badge bg-light me-3">&nbsp;</span>
			                      <div class="d-flex flex-column justify-content-center">
			                        <h6 class="mb-0 text-sm">OFFICE SUPPLIES</h6>
			                      </div>
			                    </div>
			                  </td>
			                  <td class="text-sm text-center align-middle">
			                    <span class="text-xs font-weight-bold">{{ totPersenOfficeSupp }}%</span>
			                  </td>
			                </tr>
			              </tbody>
			            </table>
			          </div>
			        </div>
			      </div>

			    </div>
			  </div>
    	</div>

    </div>

    <div class="row">
      <div class="col-lg-6">
        <div class="card mb-5"> 
          <div class="row">
            <div class="col-lg-6">
              <div class="card-header pb-0 text-center">
                <h6>LEAD TIME PR TO PO BY ITEM CATEGORY</h6>
              </div>
            </div>
            <div class="col-lg-6 float-right">
              <argon-button
                style="margin-right: 10px; margin-left: 60px;"
                class="mt-0"
                variant="gradient"
                color="secondary"
                size="sm"
                @click="filter()"
              ><i class="fa fa-filter fa-sm" aria-hidden="true"></i> Filter</argon-button>
              <a class="btn btn-sm btn-success mt-3" style="margin-right: 10px;" :href="apiUrl+'export-excel/lead-time-item-category'" target="_BLANK"><i class="fa fa-file-excel-o"></i> Export to Excel</a>
            </div>
          </div>
          <div class="card-body px-0 pt-0 pb-2 mt-0">
            <div class="table-responsive p-0">
              <table class="table table-sm table-hover table-striped align-items-center mb-0 mt-0">
                <thead>
                  <tr>
                    <th class="text-center text-uppercase text-white text-xxs font-weight-bolder" style="background-color: #6495ED;">NO</th>
                    <th class="text-center text-uppercase text-white text-xxs font-weight-bolder" style="background-color: #6495ED;">ITEM CATEGORY</th>
                    <th class="text-center text-uppercase text-white text-xxs font-weight-bolder" style="background-color: #6495ED;">JANUARY 2025</th>
                    <th class="text-center text-uppercase text-white text-xxs font-weight-bolder" style="background-color: #6495ED;">FEBRUARY 2025</th>
                    <th class="text-center text-uppercase text-white text-xxs font-weight-bolder" style="background-color: #6495ED;">MARCH 2025</th>
                    <th class="text-center text-uppercase text-white text-xxs font-weight-bolder" style="background-color: #6495ED;">APRIL 2025</th>
                    <th class="text-center text-uppercase text-white text-xxs font-weight-bolder" style="background-color: #6495ED;">MAY 2025</th>
                    <th class="text-center text-uppercase text-white text-xxs font-weight-bolder" style="background-color: #6495ED;">JUNE 2025</th>
                    <th class="text-center text-uppercase text-white text-xxs font-weight-bolder" style="background-color: #6495ED;">JULY 2025</th>
                    <th class="text-center text-uppercase text-white text-xxs font-weight-bolder" style="background-color: #6495ED;">AUGUST 2025</th>
                    <th class="text-center text-uppercase text-white text-xxs font-weight-bolder" style="background-color: #6495ED;">SEPTEMBER 2025</th>
                    <th class="text-center text-uppercase text-white text-xxs font-weight-bolder" style="background-color: #6495ED;">OCTOBER 2025</th>
                    <th class="text-center text-uppercase text-white text-xxs font-weight-bolder" style="background-color: #6495ED;">NOVEMBER 2025</th>
                    <th class="text-center text-uppercase text-white text-xxs font-weight-bolder" style="background-color: #6495ED;">DECEMBER 2025</th>
                    <th class="text-center text-uppercase text-white text-xxs font-weight-bolder" style="background-color: #6495ED;">JANUARY 2026</th>
                    <th class="text-center text-uppercase text-white text-xxs font-weight-bolder" style="background-color: #6495ED;">FEBRUARY 2026</th>
                    <th class="text-center text-uppercase text-white text-xxs font-weight-bolder" style="background-color: #6495ED;">MARCH 2026</th>
                    <th class="text-center text-uppercase text-white text-xxs font-weight-bolder" style="background-color: #6495ED;">APRIL 2026</th>
                    <th class="text-center text-uppercase text-white text-xxs font-weight-bolder" style="background-color: #6495ED;">MAY 2026</th>
                    <th class="text-center text-uppercase text-white text-xxs font-weight-bolder" style="background-color: #6495ED;">JUNE 2026</th>
                    <th class="text-center text-uppercase text-white text-xxs font-weight-bolder" style="background-color: #6495ED;">JULY 2026</th>
                    <th class="text-center text-uppercase text-white text-xxs font-weight-bolder" style="background-color: #6495ED;">AUGUST 2026</th>
                    <th class="text-center text-uppercase text-white text-xxs font-weight-bolder" style="background-color: #6495ED;">SEPTEMBER 2026</th>
                    <th class="text-center text-uppercase text-white text-xxs font-weight-bolder" style="background-color: #6495ED;">OCTOBER 2026</th>
                    <th class="text-center text-uppercase text-white text-xxs font-weight-bolder" style="background-color: #6495ED;">NOVEMBER 2026</th>
                    <th class="text-center text-uppercase text-white text-xxs font-weight-bolder" style="background-color: #6495ED;">DECEMBER 2026</th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-for="(row, i) in data" :key="row.category">
                    <td class="align-middle text-center text-sm">
                      <span class="text-secondary text-xs font-weight-bold text-uppercase">{{ i + 1 }}. </span>
                    </td>
                    <td class="align-middle text-left text-sm">
                      <span class="text-secondary text-xs font-weight-bold text-uppercase" v-if="row.category == 'A'">  MATERIAL </span>
                      <span class="text-secondary text-xs font-weight-bold text-uppercase" v-if="row.category == 'B'">  CONSUMABLE </span>
                      <span class="text-secondary text-xs font-weight-bold text-uppercase" v-if="row.category == 'C'">  WORKSHOP SERVICES </span>
                      <span class="text-secondary text-xs font-weight-bold text-uppercase" v-if="row.category == 'D'">  TOOLS AND EQUIPMENTS </span>
                      <span class="text-secondary text-xs font-weight-bold text-uppercase" v-if="row.category == 'E'">  OFFICE EQUIPMENT </span>
                      <span class="text-secondary text-xs font-weight-bold text-uppercase" v-if="row.category == 'F'">  GENERAL AND ADMINISTRATIVE </span>
                      <span class="text-secondary text-xs font-weight-bold text-uppercase" v-if="row.category == 'G'">  FINISHING GOODS </span>
                      <span class="text-secondary text-xs font-weight-bold text-uppercase" v-if="row.category == 'H'">  OFFICE SUPPLIES </span>
                    </td>
                    <td class="align-middle text-center text-sm" v-for="month in monthKeys" :key="month">
                      <span class="text-secondary text-xs font-weight-bold text-uppercase">  {{ row[month] !== null ? row[month] +' Day': '-' }} </span>
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </div>

      <div class="col-lg-6">
        <!-- CHART BAR DATA -->
        <div class="card mb-3"> 
          <div class="card-header pb-0 text-center align-content-center justify-content-center">
            <div class="row">
              <div class="col-12">
                <h6 class="text-center">CHART OF INVOICES PAID BY FINANCE</h6>
              </div>
             <!--  <div class="col-2">
                <select class="form-select" aria-label="Default select example" @change="changeBarChart()" v-model="yearBarChart">
                  <option value="2026" >2026</option>
                  <option value="2025" >2025</option>
                  <option value="2024" >2024</option>
                  <option value="2023" >2023</option>
                  <option value="2022" >2022</option>
                  <option value="2021" >2021</option>
                  <option value="2019" >2019</option>
                  <option value="2018" >2018</option>
                </select>
              </div> -->
            </div>
          </div>
          <div class="card-body mt-n3">
            <div class="pt-3 chart">
              <canvas id="chart-line" class="chart-canvas" height="250"></canvas>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class=" row">
      <div class="col-12">
          <div class="card"> 
            <div class="row">
              <div class="col-lg-3">
              </div>
              <div class="col-lg-6">
                <div class="card-header pb-0 text-center">
                  <h6>DASHBOARD MATERIAL SUPPLY & SUB CONTRACT STATUS</h6>
                  <!-- <h6 style="margin-top: -10px;">PT. DAEKYUG INDAH HEAVY INDUSTRY</h6> -->
                </div>
              </div>
              <div class="col-lg-3 float-right">
                <argon-button
                  style="margin-right: 10px; margin-left: 60px;"
                  class="mt-4"
                  variant="gradient"
                  color="secondary"
                  size="sm"
                  @click="filter()"
                ><i class="fa fa-filter fa-sm" aria-hidden="true"></i> Filter</argon-button>
                <a class="btn btn-sm btn-success mt-5" style="margin-right: 10px;" :href="apiUrl+'export-excel/dashboard-purchasing?wo_code='+search.wo_code+'&pr_code='+search.pr_code+'&pr_date='+search.pr_date+'&project_type='+search.project_type+'&part_name='+search.part_name+'&specification='+search.specification+'&size='+search.size+'&status='+search.status+'&pic_rfq='+search.pic_rfq+'&rfq_no='+search.rfq_no+'&po_no='+search.po_no+'&po_date='+search.po_date+''" target="_BLANK"><i class="fa fa-file-excel-o"></i> Export to Excel</a>
              </div>
            </div>
            
            <div class="card-body px-0 pt-0 pb-2 mt-4">
              <div class="table-responsive p-0 scroll">
                <table class="table table-sm table-bordered table-hover table-striped align-items-center mb-0">
                  <thead>
                    <tr>
                      <th rowspan="2" class="text-center text-uppercase text-white text-xxs font-weight-bolder" style="background-color: #008B8B;">No</th>
                      <th rowspan="2" class="text-center text-uppercase text-white text-xxs font-weight-bolder" style="background-color: red;">TRACKING</th>
                      <th rowspan="2" class="text-center text-uppercase text-white text-xxs font-weight-bolder" style="background-color: #008B8B;">WO NO</th>
                      <th rowspan="2" class="text-center text-uppercase text-white text-xxs font-weight-bolder" style="background-color: #008B8B;">CLIENT</th>
                      <th rowspan="2" class="text-center text-uppercase text-white text-xxs font-weight-bolder" style="background-color: #008B8B;">CONTRACT DELIVERY</th>
                      <th colspan="3" class="text-center text-uppercase text-white text-xxs font-weight-bolder">PR Status</th>
                      <th colspan="9" class="text-center text-uppercase text-white text-xxs font-weight-bolder">PR Item Description</th>
                      <th rowspan="2" class="text-center text-uppercase text-white text-xxs font-weight-bolder" style="background-color: red;">PIC PROC</th>
                      <!-- <th rowspan="2" class="text-center text-uppercase text-white text-xxs font-weight-bolder">Category <br> (Local / <br> Import )</th> -->
                      <!-- <th rowspan="2" class="text-center text-uppercase text-white text-xxs font-weight-bolder">LONGLEAD</th> -->
                      <th colspan="2" class="text-center text-uppercase text-white text-xxs font-weight-bolder" style="background-color: #DAA520;">RFQ STATUS</th>
                      <!-- <th rowspan="2" class="text-center text-uppercase text-white text-xxs font-weight-bolder" style="background-color: #DAA520;">CATATAN DISPOSISI</th> -->
                      <th colspan="9" class="text-center text-uppercase text-white text-xxs font-weight-bolder" style="background-color: #32CD32;">PO. STATUS</th>
                      <th colspan="3" class="text-center text-uppercase text-white text-xxs font-weight-bolder" style="background-color: #A52A2A;">Receiveng STATUS</th>
                      <th rowspan="2" class="text-center text-uppercase text-white text-xxs font-weight-bolder">ACTION</th>
                    </tr>
                    <tr>
                      <th class="text-center text-uppercase text-white text-xxs font-weight-bolder ">PR Issued</th>
                      <th class="text-center text-uppercase text-white text-xxs font-weight-bolder ">P/R NO</th>
                      <th class="text-center text-uppercase text-white text-xxs font-weight-bolder ">REQUEST BY</th>
                      <th class="text-center text-uppercase text-white text-xxs font-weight-bolder ">PR Item No.</th>
                      <th class="text-center text-uppercase text-white text-xxs font-weight-bolder">PART NAME</th>
                      <th class="text-center text-uppercase text-white text-xxs font-weight-bolder">SPECIFICATION</th>
                      <th class="text-center text-uppercase text-white text-xxs font-weight-bolder">SIZE</th>
                      <th class="text-center text-uppercase text-white text-xxs font-weight-bolder">UNIT</th>
                      <th class="text-center text-uppercase text-white text-xxs font-weight-bolder">QTY</th>
                      <th class="text-center text-uppercase text-white text-xxs font-weight-bolder ">Item No.</th>
                      <th class="text-center text-uppercase text-white text-xxs font-weight-bolder ">USE FOR</th>
                      <th class="text-center text-uppercase text-white text-xxs font-weight-bolder ">STATUS</th>
                      <th class="text-center text-uppercase text-white text-xxs font-weight-bolder " style="background-color: #DAA520;">RFQ NO.</th>
                      <th class="text-center text-uppercase text-white text-xxs font-weight-bolder " style="background-color: #DAA520;">RFQ DATE</th>
                      <!-- <th class="text-center text-uppercase text-white text-xxs font-weight-bolder " style="background-color: #DAA520;">RFQ/ COMPARE</th> -->
                      <!-- <th class="text-center text-uppercase text-white text-xxs font-weight-bolder " style="background-color: #DAA520;">DATA COMPARE SUPLIER</th> -->
                      <th class="text-center text-uppercase text-white text-xxs font-weight-bolder " style="background-color: #32CD32;">PO SCHEDULE BY PROC</th>
                      <th class="text-center text-uppercase text-white text-xxs font-weight-bolder " style="background-color: #32CD32;">PO NO.</th>
                      <th class="text-center text-uppercase text-white text-xxs font-weight-bolder " style="background-color: #32CD32;">DATE</th>
                      <th class="text-center text-uppercase text-white text-xxs font-weight-bolder" style="background-color: #32CD32;">VENDOR</th>
                      <th class="text-center text-uppercase text-white text-xxs font-weight-bolder" style="background-color: #32CD32;">PO DELIVERY DATE</th>
                      <th class="text-center text-uppercase text-white text-xxs font-weight-bolder" style="background-color: #32CD32;">DELIVERY CONDITION</th>
                      <th class="text-center text-uppercase text-white text-xxs font-weight-bolder" style="background-color: #32CD32;">PAYMENT <br> TERM</th>
                      <th class="text-center text-uppercase text-white text-xxs font-weight-bolder" style="background-color: #32CD32;">UNIT PRICE</th>
                      <th class="text-center text-uppercase text-white text-xxs font-weight-bolder" style="background-color: #32CD32;">TOTAL PRICE</th>
                      <th class="text-center text-uppercase text-white text-xxs font-weight-bolder" style="background-color: #A52A2A;">Receiveng No.</th>
                      <th class="text-center text-uppercase text-white text-xxs font-weight-bolder" style="background-color: #A52A2A;">Date</th>
                      <th class="text-center text-uppercase text-white text-xxs font-weight-bolder" style="background-color: #A52A2A;">Qty</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr v-for="(row, i) in table.data" :key="i" @click="setBg(i)" :style="(backgroundRed == i) ? 'background-color: #7FFF00; cursor: pointer;' : 'cursor: pointer;' ">
                      <td class="align-middle text-center text-sm">
                        <span class="text-secondary text-xs font-weight-bold">{{ i + 1 }}</span>
                      </td>
                      <td class="align-middle text-center text-sm">
                        <span class="badge badge-sm bg-gradient-secondary" v-if="row.status == 'Draf'">{{ row.status }} </span>
                        <span class="badge badge-sm bg-gradient-info" v-else-if="row.status == 'PR Approved'">{{ row.status }} </span>
                        <span class="badge badge-sm bg-gradient-danger" v-else-if="row.status == 'On RFQ'">{{ row.status }} </span>
                        <span class="badge badge-sm bg-gradient-warning" v-else-if="row.status == 'RFQ Completed'">{{ row.status }} </span>
                        <span class="badge badge-sm bg-gradient-text-light bg-dark" v-else-if="row.status == 'On Comparison'">{{ row.status }} </span>
                        <span class="badge badge-sm bg-gradient-muted bg-dark" v-else-if="row.status == 'CP Approved'">{{ row.status }} </span>
                        <span class="badge badge-sm bg-gradient-primary" v-else-if="row.status == 'On Purchase Order'">{{ row.status }} </span>
                        <span class="badge badge-sm bg-gradient-success" v-else-if="row.status == 'Fixed PO'">{{ row.status }} </span>
                        <span class="badge badge-sm bg-gradient-danger" v-else-if="row.status == 'Canceled'">{{ row.status }} </span>
                        <span class="badge badge-sm bg-gradient-warning" v-else>{{ row.status }} </span>
                      </td>
                      <td class="align-middle text-center text-sm">
                        <span class="text-secondary text-xs font-weight-bold">{{ row.wo_code }}</span>
                      </td>
                      <td class="align-middle text-left text-sm">
                        <span class="text-secondary text-xs font-weight-bold">{{ row.client }}</span>
                      </td>
                      <td class="align-middle text-center text-sm">
                        <span class="text-secondary text-xs font-weight-bold">{{ moment(row.contract_delivery).locale('id').format('ll') }}</span>
                      </td>
                      <td class="align-middle text-center text-sm">
                        <span class="text-secondary text-xs font-weight-bold">{{ moment(row.pr_issued).locale('id').format('ll') }}</span>
                      </td>
                      <td class="align-middle text-left text-sm">
                        <span class="badge badge-sm bg-gradient-primary">  {{ row.pr_code }} </span>
                      </td>
                       <td class="align-middle text-left text-sm">
                        <span class="text-secondary text-xs font-weight-bold"> {{ row.created_by }} </span>
                      </td>
                      <td class="align-middle text-center text-sm text-uppercase">
                        <span class="text-secondary text-xs font-weight-bold"> {{ row.no_item }} </span>
                      </td>
                      <td class="align-middle text-left text-sm text-uppercase">
                        <span class="text-secondary text-xs font-weight-bold"> {{ row.part_name }} </span>
                      </td>
                      <td class="align-middle text-left text-sm text-uppercase">
                        <span class="text-secondary text-xs font-weight-bold"> {{ row.specification }} </span>
                      </td>
                      <td class="align-middle text-left text-sm text-uppercase">
                        <span class="text-secondary text-xs font-weight-bold"> {{ row.size }} </span>
                      </td>
                      <td class="align-middle text-center text-sm text-uppercase">
                        <span class="text-secondary text-xs font-weight-bold"> {{ row.unit }} </span>
                      </td>
                      <td class="align-middle text-center text-sm">
                        <span class="text-secondary text-xs font-weight-bold"> {{ row.qty }} </span>
                      </td>
                      <td class="align-middle text-center text-sm">
                        <span class="text-secondary text-xs font-weight-bold"> {{ row.item_no }} </span>
                      </td>
                      <td class="align-middle text-center text-sm">
                        <span class="text-secondary text-xs font-weight-bold"> {{ row.use_for }} </span>
                      </td>
                      <td class="align-middle text-center text-sm">
                        <span class="text-secondary text-xs font-weight-bold"> {{ row.status_item }} </span>
                      </td>
                      <td class="align-middle text-center text-sm">
                        <span class="text-secondary text-xs font-weight-bold"> {{ row.pic_rfq }} </span>
                      </td>
                      <!-- <td class="align-middle text-center text-sm">
                        <span class="text-secondary text-xs font-weight-bold"> Lokal </span>
                      </td>
                      <td class="align-middle text-center text-sm">
                        <span class="text-secondary text-xs font-weight-bold"> Longlead </span>
                      </td> -->
                      <td class="align-middle text-center text-sm">
                        <span class="text-secondary text-xs font-weight-bold"> {{ row.rfq_code }} </span>
                      </td>
                      <td class="align-middle text-center text-sm">
                        <span class="text-secondary text-xs font-weight-bold" v-if="row.rfq_date"> {{ moment(row.rfq_date).locale('id').format('ll') }} </span>
                      </td>
                      <!-- <td class="align-middle text-center text-sm">
                        <span class="text-secondary text-xs font-weight-bold"> DATA COMPARE SUPLIER </span>
                      </td>
                      <td class="align-middle text-center text-sm">
                        <span class="text-secondary text-xs font-weight-bold"> CATATAN </span>
                      </td> -->
                      <!-- <td class="align-middle text-center text-sm">
                        <span class="text-secondary text-xs font-weight-bold"> DATE PO</span>
                      </td> -->
                      <td class="align-middle text-center text-sm">
                        <span class="text-secondary text-xs font-weight-bold">{{ moment(row.date_required).locale('id').format('ll') }} </span>
                      </td>
                      <td class="align-middle text-center text-sm">
                        <span class="text-secondary text-xs font-weight-bold"> {{ row.po_no }} </span>
                      </td>
                      <td class="align-middle text-center text-sm">
                        <span class="text-secondary text-xs font-weight-bold" v-if="row.po_date"> {{ moment(row.po_date).locale('id').format('ll') }} </span>
                      </td>
                      <td class="align-middle text-left text-sm">
                        <span class="text-secondary text-xs font-weight-bold"> {{ row.vendor }} </span>
                      </td>
                      <td class="align-middle text-center text-sm">
                        <span class="text-secondary text-xs font-weight-bold" v-if="row.del_time"> {{ row.del_time }} </span>
                      </td>
                      <td class="align-middle text-left text-sm">
                        <span class="text-secondary text-xs font-weight-bold"> {{ row.del_condition }} </span>
                      </td>
                      <td class="align-middle text-left text-sm">
                        <span class="text-secondary text-xs font-weight-bold"> {{ row.payment_terms }} </span>
                      </td>
                      <td class="align-middle text-center text-sm">
                        <span class="text-secondary text-xs font-weight-bold"> {{ row.currency }}. {{ convertRp(row.unit_price) }} </span>
                      </td>
                      <td class="align-middle text-center text-sm">
                        <span class="text-secondary text-xs font-weight-bold"> {{ row.currency }}. {{ convertRp(row.amount) }} </span>
                      </td>
                      <td class="align-middle text-left text-sm">
                        <span class="text-secondary text-xs font-weight-bold"> {{ row.receiving_no }} </span>
                      </td>
                      <td class="align-middle text-center text-sm">
                        <span class="text-secondary text-xs font-weight-bold">{{ moment(row.receiving_date).locale('id').format('ll') }} </span>
                      </td>
                      <td class="align-middle text-center text-sm" :style="(row.qty == row.receiving_qty) ? 'background-color: #7FFF00;' : 'background-color: red;' ">
                        <span class="text-secondary text-xs font-weight-bold">{{ row.receiving_qty }} </span>
                      </td>
                      <td class="align-middle text-center">
                        <i class="fa fa-window-close fa-sm" aria-hidden="true" title="Cancel item ini" style="cursor: pointer; margin-right: 20px;" @click="prItemCancle(row.id)"></i>
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>
            <div class="card-footer">
              <div class="float-left">TOTAL ROWS : {{table.data.length}} </div>
              <div class="float-right">
                <base-pagination :page-count="pagination.page_count" :value="pagination.page" @input="changePage" :total="pagination.page_count" class="justify-content-end"></base-pagination>
              </div>
            </div>
          </div>
      </div>
    </div>
  </div>

   <!-- ================================================  MODAL FILTER ============================================== -->
  <div class="container">
    <vue-final-modal v-model="formFilter.show" classes="modal-container" content-class="modal-content" :z-index="10000">
      <!-- header -->
      <div class="row">
        <div class="col-11 float-left">
          <span class="modal__title">{{formFilter.title}}</span>
        </div>
        <div class="col-1 float-right">
          <i style="cursor: pointer;" class="fa fa-times" aria-hidden="true" @click="formFilter.show = false"></i>
        </div>
      </div><hr>
      <!-- end header -->
      <div class="modal__content container">
        <label for="example-text-input" class="form-control-label mt-3">WO No. </label>
        <input type="text" class="form-control" placeholder="WO No." v-model="search.wo_code" v-on:keyup.enter="getData()">
        <label for="example-text-input" class="form-control-label mt-3">PR NO </label>
        <input type="text" class="form-control" placeholder="PR NO" v-model="search.pr_code" v-on:keyup.enter="getData()">
        <label for="example-text-input" class="form-control-label mt-3">PR Date</label> 
        <flat-pickr :config="{ mode: 'range',}" class="form-control" v-model="search.pr_date"/>
        <label for="example-text-input" class="form-control-label mt-3">PR Type </label>
        <select class="form-select" aria-label="Default select example" v-model="search.project_type" v-on:keyup.enter="getData()">
          <option value="Project">Project</option>
          <option value="Non Project">Non Project</option>
        </select>
        <label for="example-text-input" class="form-control-label mt-3">Part Name </label>
        <input type="text" class="form-control" placeholder="Part Name" v-model="search.part_name" v-on:keyup.enter="getData()">
        <label for="example-text-input" class="form-control-label mt-3">Specification </label>
        <input type="text" class="form-control" placeholder="Specification" v-model="search.specification" v-on:keyup.enter="getData()">
        <label for="example-text-input" class="form-control-label mt-3">Size </label>
        <input type="text" class="form-control" placeholder="Size" v-model="search.size" v-on:keyup.enter="getData()">
        <label for="example-text-input" class="form-control-label mt-3">Use For </label>
        <input type="text" class="form-control" placeholder="Use For" v-model="search.use_for" v-on:keyup.enter="getData()">
        <label for="example-text-input" class="form-control-label mt-3">Tracking Status </label>
        <select class="form-select" aria-label="Default select example" v-model="search.status" v-on:keyup.enter="getData()">
          <option value="Draf">Draf</option>
          <option value="PR Approved">PR Approved</option>
          <option value="On RFQ">On RFQ</option>
          <option value="RFQ Completed">RFQ Completed</option>
          <option value="On Comparison">On Comparison</option>
          <option value="CP Approved">CP Approved</option>
          <option value="On Purchase Order">On Purchase Order</option>
          <option value="Fixed PO">Fixed PO</option>
          <option value="Already Received">Already Received</option>
          <option value="Canceled">Canceled</option>
          <option value="Report PO">Report PO</option>
          <option value="Tracking All">Tracking All</option>
        </select>
        <label for="example-text-input" class="form-control-label mt-3">PIC Proc </label>
        <input type="text" class="form-control" placeholder="PIC Proc" v-model="search.pic_rfq" v-on:keyup.enter="getData()">
        <label for="example-text-input" class="form-control-label mt-3">RFQ No. </label>
        <input type="text" class="form-control" placeholder="RFQ No." v-model="search.rfq_no" v-on:keyup.enter="getData()">
        <label for="example-text-input" class="form-control-label mt-3">PO No. </label>
        <input type="text" class="form-control" placeholder="PO No." v-model="search.po_no" v-on:keyup.enter="getData()">
        <label for="example-text-input" class="form-control-label mt-3">PO Date</label> 
        <flat-pickr :config="{ mode: 'range',}" class="form-control" v-model="search.po_date"/>
        <label for="example-text-input" class="form-control-label mt-3">Vendor Name </label>
        <input type="text" class="form-control mb-4" placeholder="Vendor Name" v-model="search.vendor" v-on:keyup.enter="getData()">
      </div>
      <!-- footer -->
      <div class="row float-right mt-3">
        <div class="col-6"> 
        </div>
        <div class="col-2" style="margin-right: 20px;">
          <argon-button  variant="gradient" color="secondary" size="sm" width="1" @click="search = {}">Clear</argon-button>
        </div>
        <div class="col-1">
          <argon-button variant="gradient" color="success" size="sm" width="1" @click="getData()" :disabled="onLoading">
            <span v-if="onLoading"><i class="fa fa-spinner fa-spin"></i> Please Wait...</span>
            <span v-else>
                <span>Filter</span>
            </span>
          </argon-button>
        </div>
      </div>
      <!-- end footer -->
    </vue-final-modal>
   </div>

</template>

<script>
import Card from "@/examples/Cards/Card.vue";
import ArgonButton from "@/components/ArgonButton.vue"; 
import { VueFinalModal } from 'vue-final-modal'
import BasePagination from "@/components/BasePagination";
import Api from '@/helpers/api';
import config from '@/configs/config';
import { toast } from 'vue3-toastify';
import Chart from "chart.js/auto";
import { Chart as ChartJS, ArcElement, Tooltip, Legend } from 'chart.js'
import { Pie } from 'vue-chartjs'
import flatPickr from 'vue-flatpickr-component';
import 'flatpickr/dist/flatpickr.css';
// import 'vue3-toastify/dist/index.css';
// import Multiselect from 'vue-multiselect'
import 'vue-multiselect/dist/vue-multiselect.css';
var moment = require('moment');
import purchasingRequisition from '@/services/procurement/purchasingRequisition.service';
import workOrder from '@/services/procurement/workOrder.service';
import materialGroupPR from '@/services/procurement/materialGroupPR.service';

ChartJS.register(ArcElement, Tooltip, Legend)

export default {
  name: "tables",
  components: {
  	Card,
    flatPickr,
    ArgonButton,
    VueFinalModal,
    // Multiselect,
    BasePagination,
    Pie,
  },
  data() {
    return {
      pagination: {
        page_count: '',
        page: 1,
      },
      moment:moment,
      table: {
        data: []
      },
      tableLeadTime: {
        data: []
      },
      tableInvoiceFinance: {
        data: []
      },
      formFilter: {
        add: true,
        title: "Filter",
        show: false
      },
      onLoading: false,
      storageUrl : config.storageUrl,
      backgroundRed: null,

      headerData: {},
      search: {
        pr_code: '',
        pr_date: '',
        project_type: '',
        part_name: '',
        specification: '',
        size: '',
        use_for: '',
        status: '',
        pic_rfq: '',
        rfq_no: '',
        po_no: '',
        po_date: '',
        vendor: '',
      },
      apiUrl :config.apiUrl,

	  totalWo: '',
	  totalVendor: '',
	  totalItem: '',
	  totalPr: '',
	  totalRfq: '',
	  totalCp: '',
	  totalPo: '',

    totPersenDirect: '',
    totPersenIndirect: '',

	  totPersenMtr: '',
	  totPersenCons: '',
	  totPersenWs: '',
	  totPersenTools: '',
	  totPersenOfficeEquip: '',
	  totPersenGenAdm: '',
	  totPersenFinishGoods: '',
	  totPersenOfficeSupp: '',

    chartData: {
      labels: [],
      datasets: [
        {
          label: '',
          labelTwo: '',
          backgroundColor: '',
          data: []
        }, 
      ],
    },

    data: [], // diisi dari API
    monthKeys: [],

    chartMonth: [],
    chartLineValue: [],

    };
  },
  mounted(){
    this.getData();
    this.getChart();
    this.getLeadTimeCategpry();
    this.getInvoicePaidByFinance();
    this.tokenApi = 'Bearer '+localStorage.getItem('token');
  },
  methods: {
    getData(param){
      let context = this; 
      context.onLoading = true;

      Api(context, purchasingRequisition.getMonitoringPrItem({wo_code: this.search.wo_code, pr_code: this.search.pr_code, pr_date: this.search.pr_date, project_type: this.search.project_type, part_name: this.search.part_name, specification: this.search.specification, size: this.search.size, use_for: this.search.use_for, status: this.search.status, pic_rfq: this.search.pic_rfq, rfq_no: this.search.rfq_no, po_no: this.search.po_no, po_date: this.search.po_date, vendor: this.search.vendor, page: context.pagination.page})).onSuccess(function(response) {    
          context.table.data            = response.data.data.data.data;
          context.pagination.page_count = response.data.data.data.last_page

			context.totalWo     = response.data.data.totalWo
			context.totalVendor = response.data.data.totalVendor
			context.totalItem   = response.data.data.totalItem
			context.totalPr     = response.data.data.totalPr
			context.totalRfq    = response.data.data.totalRfq
			context.totalCp     = response.data.data.totalCp
			context.totalPo     = response.data.data.totalPo

          context.notify('Data Retrieved Successfully', 'success')
      }).onError(function(error) {                    
          if (error.response.status == 404) {
              context.table.data = [];
          }
          context.notify('Data Retrieved Failed', 'error')
      }).onFinish(function() { 
         context.formFilter.show = false;
         context.onLoading       = false;
         
      })
      .call()
    },
    getChart(param){
      let context = this; 
      context.onLoading = true;

      Api(context, purchasingRequisition.getChart({wo_code: this.search.wo_code, pr_code: this.search.pr_code, project_type: this.search.project_type, part_name: this.search.part_name, specification: this.search.specification, size: this.search.size, status: this.search.status, pic_rfq: this.search.pic_rfq, rfq_no: this.search.rfq_no, po_no: this.search.po_no, page: context.pagination.page})).onSuccess(function(response) {

      context.totPersenDirect   = response.data.data.totPersenDirect
      context.totPersenIndirect = response.data.data.totPersenIndirect

      context.totPersenMtr         = response.data.data.totPersenMtr
			context.totPersenCons        = response.data.data.totPersenCons
			context.totPersenWs          = response.data.data.totPersenWs
			context.totPersenTools       = response.data.data.totPersenTools
			context.totPersenOfficeEquip = response.data.data.totPersenOfficeEquip
			context.totPersenGenAdm      = response.data.data.totPersenGenAdm
			context.totPersenFinishGoods = response.data.data.totPersenFinishGoods
			context.totPersenOfficeSupp  = response.data.data.totPersenOfficeSupp
      }).onError(function(error) {                    

      }).onFinish(function() { 
         context.pieChart()
         context.doughnutChart()
      })
      .call()
    },
    getLeadTimeCategpry(param){
      let context = this; 
      context.onLoading = true;

      Api(context, purchasingRequisition.getLeadTime()).onSuccess(function(response) {    
          context.tableLeadTime.data = response.data.data.leadTimes;
          context.data               = response.data.data.leadTimes;

        // Ambil list bulan dari key object pertama (kecuali 'category')
        if (context.data.length > 0) {
          context.monthKeys = Object.keys(context.data[0]).filter(key => key !== 'category');
        }

          context.notify('Data Retrieved Successfully', 'success')
      }).onError(function(error) {                    
          if (error.response.status == 404) {
              context.table.data = [];
          }
          context.notify('Data Retrieved Failed', 'error')
      }).onFinish(function() { 
         context.formFilter.show = false;
         context.onLoading       = false;
         
      })
      .call()
    },
    getInvoicePaidByFinance(param){
      let context = this; 
      context.onLoading = true;

      Api(context, purchasingRequisition.getInvoiceFinance()).onSuccess(function(response) {    
          context.tableInvoiceFinance.data = response.data.data.data;

          context.chartMonth     = response.data.data.data.map(item => item.period);
          context.chartLineValue = response.data.data.data.map(item => item.total_amount);

        // Ambil list bulan dari key object pertama (kecuali 'category')
        // if (context.data.length > 0) {
        //   context.monthKeys = Object.keys(context.data[0]).filter(key => key !== 'category');
        // }

          context.notify('Data Retrieved Successfully', 'success')
      }).onError(function(error) {                    
          if (error.response.status == 404) {
              context.table.data = [];
          }
          context.notify('Data Retrieved Failed', 'error')
      }).onFinish(function() { 
         context.formFilter.show = false;
         context.onLoading       = false;
         context.getChartLine();
         
      })
      .call()
    },
    filter() {
      this.formFilter.add   = true;
      this.formFilter.show  = true;
      this.formFilter.title = "Filter";
      this.onLoading        = false;
      this.pagination.page  = 1 ;
    },
    prItemCancle(id){
      let api      = null;
      let context  = this;

      api = Api(context, purchasingRequisition.prItemCancle(id));
      // eslint-disable-next-line no-unused-vars
      api.onSuccess(function(response) {
        context.getData();
        context.notify((context.form === 'Add Data') ? 'Data Berhasil di Simpan' : 'Data Berhasil di Update', 'success')
      // eslint-disable-next-line no-unused-vars
      }).onError(function(error) { 
        context.notify((context.form != 'Add Data') ? 'Data Gagal di Simpan' : 'Data Gagal di Update', 'error')                   
      }).onFinish(function() {  
      })
      .call();
    },
    changePage(page){
      this.pagination.page = page;
      this.getData();
    },
    setBg(id) {
      this.backgroundRed = id
    },
    convertRp(bilangan) {
      if (bilangan) {
        var number_string = bilangan.toString(),
            sisa    = number_string.length % 3,
            rupiah  = number_string.substr(0, sisa),
            ribuan  = number_string.substr(sisa).match(/\d{3}/g);

        if(ribuan){
          var separator = sisa ? '.' : '';
          rupiah += separator + ribuan.join('.');
          return rupiah
        }else{
          return bilangan
        }
      }
    },
    notify(message, type) {
      if (type == 'success') {
        toast.success(message, {
          position: toast.POSITION.BOTTOM_RIGHT,
          autoClose: 2000,
        }); // ToastOptions
      }else{
        toast.error(message, {
          position: toast.POSITION.BOTTOM_RIGHT,
          autoClose: 2000,
        }); // ToastOptions
      }
    },
    pieChart () {
      this.chartData = {
        labels: ['DIRECT', 'INDIRECT'],
        datasets: [
          {
            backgroundColor: ['#8FBC8F','#FF8C00'],
            data: [this.totPersenDirect, this.totPersenIndirect]
          }, 
        ],
      }
    },
    doughnutChart() {
	    // Chart Doughnut Consumption by room
	    var ctx1 = document.getElementById("chart-category").getContext("2d");

	    var gradientStroke1 = ctx1.createLinearGradient(0, 230, 0, 50);

	    gradientStroke1.addColorStop(1, "rgba(203,12,159,0.2)");
	    gradientStroke1.addColorStop(0.2, "rgba(72,72,176,0.0)");
	    gradientStroke1.addColorStop(0, "rgba(203,12,159,0)"); //purple colors

	    new Chart(ctx1, {
	      type: "doughnut",
	      data: {
	        labels: ["MATERIAL", "CONSUMABLE", "WORKSHOP SERVICES", "TOOLS AND EQUIPMENTS", "OFFICE EQUIPMENT", "GENERAL AND ADMINISTRATIVE", "FINISHING GOODS", "OFFICE SUPPLIES"],
	        datasets: [
	          {
	            label: "Consumption",
	            weight: 9,
	            cutout: 90,
	            tension: 0.9,
	            pointRadius: 2,
	            borderWidth: 2,
	            backgroundColor: [
	              "#5e72e4",
	              "#8392ab",
	              "#11cdef",
	              "#2dce89",
	              "#fb6340",
	              "#324366",
	              "#F9385C",
	              "#EAEDF0",
	            ],

	            data: [this.totPersenMtr, this.totPersenCons, this.totPersenWs, this.totPersenTools, this.totPersenOfficeEquip, this.totPersenGenAdm, this.totPersenFinishGoods, this.totPersenOfficeSupp],
	            fill: false,
	          },
	        ],
	      },
	      options: {
	        responsive: true,
	        maintainAspectRatio: false,
	        plugins: {
	          legend: {
	            display: false,
	          },
	        },
	        interaction: {
	          intersect: false,
	          mode: "index",
	        },
	        scales: {
	          y: {
	            grid: {
	              drawBorder: false,
	              display: false,
	              drawOnChartArea: false,
	              drawTicks: false,
	            },
	            ticks: {
	              display: false,
	            },
	          },
	          x: {
	            grid: {
	              drawBorder: false,
	              display: false,
	              drawOnChartArea: false,
	              drawTicks: false,
	            },
	            ticks: {
	              display: false,
	            },
	          },
	        },
	      },
	    });
	  },
    // CHART LINE
    getChartLine(){
      var ctx1 = document.getElementById("chart-line").getContext("2d");

      var gradientStroke1 = ctx1.createLinearGradient(0, 230, 0, 50);

      gradientStroke1.addColorStop(1, "rgba(94, 114, 228, 0.2)");
      gradientStroke1.addColorStop(0.2, "rgba(94, 114, 228, 0.0)");
      gradientStroke1.addColorStop(0, "rgba(94, 114, 228, 0)");

      new Chart(ctx1, {
        type: "line",
        data: {
          labels: Object.values(this.chartMonth),
          datasets: [
            {
              label: "Cost",
              tension: 0.4,
              borderWidth: 0,
              pointRadius: 0,
              borderColor: "#4BB543 ",
              backgroundColor: gradientStroke1,
              // eslint-disable-next-line no-dupe-keys
              borderWidth: 3,
              fill: true,
              data: Object.values(this.chartLineValue),
              maxBarThickness: 6,
            },
            // {
            //   label: "DB",
            //   tension: 0.4,
            //   borderWidth: 0,
            //   pointRadius: 0,
            //   borderColor: "#4BB543 ",
            //   backgroundColor: gradientStroke1,
            //   // eslint-disable-next-line no-dupe-keys
            //   borderWidth: 3,
            //   fill: true,
            //   data: [32,85,54,32],
            //   maxBarThickness: 6,
            // },
          ],
        },
        options: {
          responsive: true,
          maintainAspectRatio: false,
          plugins: {
            legend: {
              display: false,
            },
          },
          interaction: {
            intersect: false,
            mode: "index",
          },
          scales: {
            y: {
              grid: {
                drawBorder: false,
                display: true,
                drawOnChartArea: true,
                drawTicks: false,
                borderDash: [5, 5],
              },
              ticks: {
                display: true,
                padding: 10,
                color: "#fbfbfb",
                font: {
                  size: 11,
                  family: "Open Sans",
                  style: "normal",
                  lineHeight: 2,
                },
              },
            },
            x: {
              grid: {
                drawBorder: false,
                display: false,
                drawOnChartArea: false,
                drawTicks: false,
                borderDash: [5, 5],
              },
              ticks: {
                display: true,
                color: "#ccc",
                padding: 20,
                font: {
                  size: 11,
                  family: "Open Sans",
                  style: "normal",
                  lineHeight: 2,
                },
              },
            },
          },
        },
      });
    },

  }
};
</script>
<style scoped>
::v-deep .modal-container {
  display: flex;
  justify-content: center;
  align-items: center;
  overflow-y: auto;

}
::v-deep .modal-content {
  display: flex;
  flex-direction: column;
  margin: 0 1rem;
  padding: 1rem;
  border: 1px solid #e2e8f0;
  border-radius: 0.25rem;
  background: #fff;
  width: 500px;
  margin-top: auto;
  margin-bottom: auto;
}
/*MODAL WIDTH KUSUS LEBAR BESAR*/
::v-deep .modal-content-width {
  /*display: flex;*/
  /*flex-direction: column;*/
  margin: 0 1rem;
  padding: 1rem;
  border: 1px solid #e2e8f0;
  border-radius: 0.25rem;
  background: #fff;
  width: 1090px;
  margin-top: auto;
  margin-bottom: auto;
}
.modal__title {
  font-size: 1rem;
  font-weight: 600;
}
</style>

<style scoped>
.dark-mode div::v-deep .modal-content {
  border-color: #2d3748;
  background-color: #1a202c;
}
.scroll { 
  overflow: auto; 
  height: 500px; 
}
.scroll thead th { 
  position: sticky; 
  top: 0; 
  z-index: 100; 
  background-color: #6495ED;
}

/*for freze ke samping*/
.scroll table td:nth-child(2) {
  position: sticky;
  left: 0;
  background-color: white;
}
</style>
